<template>
  <Header />
  <!-- App Capsule -->
  <div id="appCapsule">

    <div class="login-form mt-5">
      <div class="section">
        <h1>ثبت نام راننده</h1>
        <h4>بزرگترین سامانه هوشمند اعلام بار کشور</h4>
      </div>
      <div class="section mt-2 mb-5">
        <form @submit.prevent="registerDriver">

          <div class="form-group boxed">
            <div class="input-wrapper">
              <label class="form-label" for="name">نام</label>
              <input type="text" @keyup="typeName" class="form-control" id="name" v-model="postData.name"
                placeholder="نام" required>
              <i class="clear-input">
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
          </div>
          <div class="form-group boxed">
            <div class="input-wrapper">
              <label class="form-label" for="lastname">نام خانوادگی</label>
              <input type="text" class="form-control" id="lastname" v-model="postData.lastName" required>
              <i class="clear-input">
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
          </div>
          <div class="form-group boxed">
            <div class="input-wrapper">
              <label class="form-label" for="nationalCode">کد ملی</label>
              <input type="text" class="form-control" id="nationalCode" v-model="postData.nationalCode" min="10"
                max="10" required>
              <i class="clear-input">
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
          </div>

          <div class="form-group boxed">
            <div class="input-wrapper">
              <label class="form-label" for="smartCode">کد هوشمند</label>
              <input type="text" class="form-control" id="smartCode" v-model="postData.smartCode" placeholder="اختیاری">
              <i class="clear-input">
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
          </div>

          <div class="form-group boxed">
            <div class="input-wrapper">
              <label class="form-label" for="fleets">انتخاب ناوگان</label>
              <select class="form-control form-select" id="fleets" v-model="postData.fleet_id" required>
                <option selected disabled value="">انتخاب کنید</option>
                <option v-for="result in results" :key="result.id" :value="result.id">{{ result.title }}</option>
              </select>
            </div>
          </div>

          <div class="form-button-group">
            <button v-if="loading == false" type="submit" class="btn background-ORANGE text-light btn-block btn-lg">
              ثبت نام
            </button>
            <button v-else class="btn background-ORANGE text-light btn-block btn-lg" type="button" disabled>
              <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
              درحال بررسی ...
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
  <!-- * App Capsule -->
</template>

<script>
import Header from "@/components/header.vue";
import axios from "axios";

export default {
  components: {
    Header
  },
  data() {
    return {
      postData: {
        mobileNumber: this.$route.params.mobileNumber,
        name: "",
        lastName: "",
        nationalCode: "",
        smartCode: "",
        fleet_id: "",
      },
      results: [],
      loading: false,

    };
  },
  methods: {
    typeName(event) {
      var p = /^[\u0622\u0627\u0628\u067E\u062A-\u062C\u0686\u062D-\u0632\u0698\u0633-\u063A\u0641\u0642\u06A9\u06AF\u0644-\u0648\u06CC]+$/;
      if (!p.test(event.currentTarget.value)) {
        this.postData.name = '';
      }
    },
    registerDriver() {
      this.loading = true;

      axios
        .post(
          "https://core.iran-tarabar.ir/api/driver/registerDriver", this.postData)
        .then((response) => {
          this.loading = false;
          if (response.data.result == 0) {
            alert(response.data.message);
          } else {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("idUser", response.data.id);
            window.location.href = "/";
          }
        });
    },
  },
  async mounted() {
    try {
      const response = await axios.get(
        "https://core.iran-tarabar.ir/api/customer/requestAllFleetsList"
      );
      this.results = response.data.fleets;
    } catch (err) {
      console.log(err);
    }
  },
};
</script>
<style></style>